import React from "react";
import { Box, Flex, Heading, Text } from "@theme-ui/components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "@emotion/styled";
import { typography } from "../../styles/theme";
const WhatIsHrGarden = ({ img, data }) => {
  return (
    <Flex
      sx={{
        justifyContent: ["space-between", "space-between", "center", "center"],
        flexDirection: ["column", "column", "row", "row"],
        alignItems: "center",
        gap: "3rem",
        my: "7rem",
      }}
    >
      <StyledBox>
        <GatsbyImage
          className="img"
          image={getImage(img)}
          alt="What-is-hr-img"
        />
      </StyledBox>
      <Flex
        sx={{
          maxWidth: ["24.69rem", "24.69rem", "27.3rem", "39.06rem"],
          flexDirection: "column",
          justifyContent: "center",
          gap: "1.5rem",
          alignItems: ["center", "center", "flex-start", "flex-start"],
        }}
      >
        <Heading as="h2" sx={{ ...typography.h2 }}>
          {data?.title}
        </Heading>
        <Flex
          sx={{
            flexDirection: ["column", "column", "column", "column"],
            gap: "0.5rem",
            alignItems: ["center", "center", "flex-start", "flex-start"],
          }}
        >
          <Heading
            sx={{
              ...typography.h3,
              textAlign: ["center", "center", "left", "left"],
            }}
          >
            {data?.subtitle}
          </Heading>
          <Text
            sx={{
              ...typography.textMd400,
              textAlign: ["center", "center", "left", "left"],
            }}
            dangerouslySetInnerHTML={{ __html: data.desc }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

const StyledBox = styled(Box)`
  .img {
    max-width: 20.064rem;
    @media (max-width: 900px) {
      max-width: 13.54rem;
    }
    @media (max-width: 600px) {
      max-width: 20.06rem;
    }
  }
`;

export default WhatIsHrGarden;
